import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { DEFAULT_LANG } from "@/i18n";
import { checkoutPath } from "@/lib/storefrontPaths";

/**
 * ``/:lang/cart/checkout`` → ``/:lang/checkout`` (KAN-922).
 *
 * The breadcrumb linked to the former for months, so the address lives
 * in e-mails, bookmarks and browser histories. Query string is carried
 * over untouched (embed / trial tokens ride there).
 */
export function LegacyCheckoutRedirect(): JSX.Element {
  const { lang = DEFAULT_LANG } = useParams<{ lang?: string }>();
  const [params] = useSearchParams();
  const query = params.toString();
  return (
    <Navigate to={`${checkoutPath(lang)}${query ? `?${query}` : ""}`} replace />
  );
}
